import React, { useEffect } from 'react';
import useDetectScroll from '@smakss/react-scroll-direction';
import Button from '../Button';
import CustomLink from '../Link';
import { LinkWithLabel, Link } from '../../../types';

import s from './index.module.scss';

const StickyButton = ({
  isStickyButtonMode,
  title,
  button,
}: {
  isStickyButtonMode: boolean;
  title?: string;
  button: LinkWithLabel;
}) => {
  const {
    scrollDir,
    scrollPosition: { top },
  } = useDetectScroll();

  useEffect(() => {
    const footer = document.querySelector('footer');
    const isVisible = isStickyButtonMode && scrollDir === 'down' && top > 65;
    footer?.classList.toggle(s['sticky-button__footer'], isVisible);
  }, [isStickyButtonMode, scrollDir, top]);

  return (
    <div
      className={`${s['sticky-button']} ${s[`sticky-button--${isStickyButtonMode && scrollDir === 'down' && top > 65 ? 'visible' : 'invisible'}`]}`}
    >
      {title && <div className={s['sticky-button__title']}>{title}</div>}
      <CustomLink {...(button.nextLink as Link)} wrapperClass={s['sticky-button__button-wrapper']}>
        <Button
          className={s['sticky-button__button']}
          isBlock
          type="primary"
          tag="a"
          withArrow
          href={button.nextLink?.url}
          data-analytics="sticky-button"
        >
          {button.label}
        </Button>
      </CustomLink>
    </div>
  );
};

export default StickyButton;
